import NotificationsIcon from './component'

export default NotificationsIcon
